import { EventEmitter } from '../classes';
import { AngularInjector } from '../angular';
import { FocusKeyboard } from 'components/focus-supervisor/services/keyboard';

export enum KeyboardEvents {
    KEYDOWN = 'keydown',
    KEYUP = 'keyup',
    KEYPRESS = 'keypress'
}

export class KeyboardEventsService extends EventEmitter {
    private specialKeys = ['F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12'];

    private focusKeyboard: FocusKeyboard = null;

    constructor(document: Document = null) {
        super();

        this.focusKeyboard = <FocusKeyboard>(<any>AngularInjector.get('fsKeyboard'));

        document = document || (window && window.document);
        if (!document) {
            throw new Error('You need set document instance to KeyboardEventsService constructor!');
        } else {
            document.addEventListener<'keydown'>(KeyboardEvents.KEYDOWN, (event: KeyboardEvent) => {
                this._emit(<string>KeyboardEvents.KEYDOWN, event);
            });
            document.addEventListener<'keyup'>(KeyboardEvents.KEYUP, (event: KeyboardEvent) => {
                this._emit(<string>KeyboardEvents.KEYUP, event);
            });
            document.addEventListener<'keypress'>(KeyboardEvents.KEYPRESS, (event: KeyboardEvent) => {
                this._emit(<string>KeyboardEvents.KEYPRESS, event);
            });
        }
    }

    private _emit(type: string, event: KeyboardEvent) {
        const key = event.key || event.code;
        if (~this.specialKeys.indexOf(key)) {
            this.focusKeyboard.setKeyboardMode();
            this.emit(`${type}.${key}`, event);
        }
        this.emit(type, event);
    }
}
